export const requiredErrorMessage = 'Please fill out this field.';
export const tooLongErrorMessage = 'Field is too long.';
